import { jsx as m } from "react/jsx-runtime";
import { forwardRef as s } from "react";
import p from "classnames";
import u from "./button-group.module.less.js";
const c = s(
  function({ className: o, ...r }, t) {
    return /* @__PURE__ */ m(
      "div",
      {
        ...r,
        className: p(u.buttonGroup, o),
        ref: t
      }
    );
  }
);
export {
  c as ButtonGroup
};
//# sourceMappingURL=button-group.js.map
